import definition from "../../brand.config";

const baseUrl = process.env.BASE_URL || "/";
const assetUrl = path => `${baseUrl}${path}`.replace(/([^:]\/)\/+/g, "$1");

export default Object.freeze({
  ...definition,
  logoUrl: assetUrl(definition.assets.logo),
  markUrl: assetUrl(definition.assets.mark),
  faviconUrl: assetUrl(definition.assets.favicon),
});
